/**
 * Send information about which filter a user clicked to a tracking service.
 */
// HACK: This is a quick-and-drity way to give us a little more insight into
// whether users interact with the filters. It's probably better to use
// something like https://github.com/react-ga/react-ga to wire this up.
function trackFilterClick(filterClicked) {
  if (!window.ga) {
    return;
  }

  // Send a custom event to Google Analytics.
  // See https://developers.google.com/analytics/devguides/collection/analyticsjs/events
  window.ga('send', 'event', 'Filters', 'change', filterClicked);
}

/**
 * Get initial state values from upstream data.
 */
function getInitialState(data) {
  return {
    grantsById: data.grantsById,
    grantIds: data.grantIds,
    filteredGrantIds: data.grantIds,
    copy: data.copy,
    filterOptions: data.filterOptions,
  };
}

/**
 * Update grant filters based on an updated filter element.
 *
 * This is meant to be called from an event handler for a form element's
 * onChange event.
 *
 * @param {object} filters - Map of grant properties to currently specified
 *   filter value.
 * @param {HTMLElement} filterEl - Form element that was most recently
 *   changed.
 *
 * @return {object} - Updated map of grant properties to filter values.
 *
 */
function updateFilters(filters, filterEl) {
  if (filterEl.name === 'show-all') {
    return {
      state: '',
      administration: '',
    };
  }

  return {
    ...filters,
    [filterEl.name]: filterEl.value,
  };
}

function filterGrantIds(filters, grantIds, grantsById) {
  return grantIds.filter(id => {
    const grant = grantsById[id];

    return Object.keys(filters).every(k => {
      const val = filters[k];

      if (val === '') {
        return true;
      }

      // HACK: Handle projects that can be in multiple states.
      if (k === 'state' && grant['state2'] === val) {
        return true;
      }

      if (grant[k] !== val) {
        return false;
      }

      return true;
    });
  });
}

export default function reducer(state, action) {
  switch (action.type) {
    case 'setdata':
      return {
        ...state,
        ...getInitialState(action.data),
      };

    case 'updatefilters':
      const filters = updateFilters(state.filters, action.filterEl);

      trackFilterClick(action.filterEl.name);

      return {
        ...state,
        filters,
        filteredGrantIds: filterGrantIds(
          filters,
          state.grantIds,
          state.grantsById
        ),
      };

    default:
      throw new Error();
  }
}
